import Axios from 'axios';
import React, { useEffect, useState } from 'react'
import NotData from '../../components/NotData';
import dayjs from 'dayjs';
import { Toast } from "../../common/message";
import { PasswordCheck } from "../../common/regCheck";
import { useNavigate } from 'react-router-dom'

const StoreUserManagement = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }
  
  const positionList = ['선택', '사장', '점장', '매니저', '수습'];
  const columns = ['No', '이용권한', '아이디', '담당매장', '닉네임', '직책', '이메일', '가입날짜'];
  const [books, setBooks] = useState([]);

  const [joinState, setJoinState] = useState('');
  
  const [userIno, setUserIno] = useState(0);
  const [userIdx, setUserIdx] = useState(0);
  const [userState, setUserState] = useState(0);
  const [userID, setUserID] = useState('');
  const [userName, setUserName] = useState('');

  const [userPassword, setUserPassword] = useState('');
  const [userPasswordCheck, setUserPasswordCheck] = useState('');

  const [userPosition, setUserPosition] = useState('');
  const [selectPosition, setSelectPosition] = useState('');

  const navigate = useNavigate();
  useEffect(()=>{
    document.title = '사용자 관리';

    if(window.sessionStorage.getItem('basicPermission') < 4){
      alert('접근할 수 없는 권한입니다');
      navigate('/sale');
    } else {
      dataLoade();
      setUserPosition('선택');
    }
  }, [])
  
  // 내역 불러오기
  const dataLoade = async () => {
    await Axios.get(`/api/storeusermanagement/list`)
    .then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  };

  // 유저 접속 허용 부분
  const UserStateBtn = async (state)=>{

    await Axios.put(`/api/storeusermanagement/userstate`, {
      UserIno: userIno, UserState: state
    })
    .then((res)=>{

      // 수정된 값으로 교체
      setBooks(()=>{
        const copy = [...books];
        copy[userIdx].state = !userState ? 1 : 0;
        return copy;
      });

    })
  }
  
  // 비밀번호 변경 함수
  const passwordChenge = async ()=>{

    if(!userIno) return alert('비밀번호를 변경할 사용자를 선택해 주세요');

    if(!userPassword) return Toast.fire({ icon: "warning", text: '비밀번호를 입력해 주세요'});
    if(!userPasswordCheck) return Toast.fire({ icon: "warning", text: '비밀번호 확인을 입력해 주세요'});
    if(userPassword !== userPasswordCheck) return Toast.fire({ icon: "warning", text: '비밀번호가 서로 다릅니다'});
    if(!PasswordCheck(userPassword)) return Toast.fire({ icon: "warning", text: '비밀번호는 영문, 숫자만 포함 6~20자리를 입력해 주세요'});

    if(!window.confirm(`${userID}(${userName})님의 비밀번호를 변경하시겠습니까?`)) return;

    await Axios.put(`/api/storeusermanagement/userpassword`, {
      UserIno: userIno, UserPassword: userPassword
    })
    .then((res)=>{
      setUserPassword('');
      setUserPasswordCheck('');
      Toast.fire({ icon: "success", text: '비밀번호를 변경했습니다'});
    })
  }
  
  // 직책 변경 함수
  const positionChange = async ()=>{

    if(!userIno) return alert('직책을 변경할 사용자를 선택해 주세요');
    if(userPosition === '선택') return alert('변경할 직책을 다시 확인해 주세요');
    if(userPosition === selectPosition) return alert('기존 직책과 변경하려는 직책이 같습니다');
    if(!window.confirm(`${userID}(${userName})님의 직책을 변경하시겠습니까?`)) return;

    // Permission 데이터 넣기
    let permission = 0;
    switch(userPosition){
      case '사장' : permission = 5; break;
      case '점장' : permission = 4; break;
      case '매니저' : permission = 3; break;
      case '수습' : permission = 2; break;
      default : break;
    }

    await Axios.put(`/api/storeusermanagement/userposition`, {
      UserIno: userIno, UserPosition: userPosition, UserPermission: permission
    })
    .then((res)=>{

      // 수정된 값으로 교체
      setBooks(()=>{
        const copy = [...books];
        copy[userIdx].position = userPosition;
        return copy;
      });

      Toast.fire({ icon: "success", text: '직책을 변경했습니다'});
    })
  }

  // 로그아웃 함수
  const userLogout = async ()=>{

    if(!window.confirm(`${userID}(${userName})님을 로그아웃 처리하시겠습니까?`)) return;

    await Axios.put(`/api/storeusermanagement/userlogout`, {
      UserIno: userIno
    })
    .then((res)=>{

      // 수정된 값으로 교체
      setBooks(()=>{
        const copy = [...books];
        copy[userIdx].login = 0;
        return copy;
      });

      Toast.fire({ icon: "success", text: '로그아웃 처리되었습니다'});
    })
  }

  // 유저 계정 삭제 함수
  const userDelete = async ()=>{

    if(!userIno) return alert('삭제할 사용자를 선택해 주세요');

    let message = window.prompt('다시 확인을 위해 삭제하실 아이디를 입력해 주세요');
    if(message === null){
      return;
    } else if(message === ''){
      return alert('아이디를 입력하지 않아 계정 삭제를 취소합니다');
    } else if(message !== userID){
      return alert('아이디가 다릅니다.');
    } 

    if(!window.confirm(`${userID}(${userName})님의 계정을 삭제하시겠습니까?`)) return;

    await Axios.put(`/api/storeusermanagement/userdelete`, {
      UserIno: userIno, Date: toDay.time
    })
    .then((res)=>{

      // 삭제 처리시 리스트에서 필터
      setBooks(books.filter(item => item.no !== userIno));

      Toast.fire({ icon: "success", text: '계정 삭제 처리되었습니다'});
    })
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  return (
    <div className="p-3 text-sm grid grid-cols-1 md:flex gap-3 md:h-[calc(100vh-4rem)] md:gap-1">

      {/* 메인 */}
      <div className="flex flex-col justify-between gap-3 md:w-3/4 w-full">

        {/* 데이터 리스트 */}
        <div className="overflow-y-auto border-[1px] border-gray-500 md:h-full h-[50vh]">
          <table className='w-full max-h-[78vh]'>
            <thead className="bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10">
              <tr className='border-b-[1px] border-gray-500'>
                {columns.map((column) => (
                  <th className="p-3" key={column}>
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-center">
              {books.length ? (
                books.map((book, idx) => (
                  <tr key={idx} className=
                  {`
                    duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                    ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                  `}
                  onClick={()=>{
                    setSelectedRow(idx);
                    setUserIno(book.no);
                    setUserIdx(idx);
                    setUserState(book.state);
                    setUserID(book.id);
                    setUserName(book.name);
                    setJoinState(()=>{
                      if(!book.state){
                        setJoinState('차단');
                      } else {
                        setJoinState('허용');
                      }
                    })
                    setUserPosition(book.position);
                    setSelectPosition(book.position);
                  }}>
                    {/* {book.cover && <img src={book.cover} alt="book `alt`.." />} */}
                    <td className="p-2.5">{idx + 1}</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500 w-32 font-semibold">
                      <p className={`tracking-widest rounded-sm px-2 py-1 ${!book.state ? 'bg-red-500/80 animate-pulse' : 'bg-blue-500/80'}`}>
                        {!book.state ? '차단' : '허용'}
                      </p>
                    </td>
                    <td className="p-2.5 border-x-[1px] border-gray-500 tracking-wide">{book.id}</td>                    
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.store}</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.name}</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.position}</td>
                    <td className="p-2.5 border-x-[1px] border-gray-500">{book.email ? book.email : `-`}</td>
                    <td className="p-2.5">{book.date.slice(0, 10)}</td>
                  </tr>
                ))
              ) : (
                <tr className="relative">
                  <td className={`absolute w-full top-[15vh] left-auto`}>
                    <NotData />                    
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* 아래 부분은 숨김처리 되어있음 */}
        {/* 하단 판매금액 */}        
        <div className={`hidden flex flex-col w-full overflow-x-auto overflow-y-hidden md:h-52 justify-center border-[1px] border-gray-500`}>
          <div className="bg-[#0067BD] h-10 py-2 text-center">
            <p className="text-left pl-3 whitespace-nowrap">
              ※ 판매내역 카드 / 현금 / 계좌이체 현황
            </p>
          </div>

          <div className="flex justify-center h-full items-center p-3 bg-[#424242]">
            <div className="flex gap-5 overflow-x-auto pb-3 whitespace-nowrap">
              <div className="">
                <p>카드 결제 {`( 2 건 )`}</p>
                <input
                  disabled
                  className="mt-3 bg-[#2E2E2E] h-14 md:w-40 w-32 rounded-md text-center border-[1px] border-gray-300"
                  type="text"
                  value={`2 원`}
                />
              </div>
              <div className="">
                <p>현금 결제 {`( 2 건 )`}</p>
                <input
                  disabled
                  className="mt-3 bg-[#2E2E2E] h-14 md:w-40 w-32 rounded-md text-center border-[1px] border-gray-300"
                  type="text"
                  value={`2 원`}
                />
              </div>
              <div className="">
                <p>이체 결제 {`( 2 건 )`}</p>
                <input
                  disabled
                  className="mt-3 bg-[#2E2E2E] h-14 md:w-40 w-32 rounded-md text-center border-[1px] border-gray-300"
                  type="text"
                  value={`2 원`}
                />
              </div>
            </div>
          </div>

        </div>

      </div>

      {/* 사이드 */}
      <div className="md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500">

        <div className="bg-[#0067BD] py-2 text-center">
          <p className="text-left pl-3">※ 등록된 사용자 관리</p>
        </div>

        <div className="p-3 flex flex-col gap-2">

          {/* 결제 현황 */}
          <div className="flex flex-col gap-3 p-3 bg-[#2E2E2E] rounded-md py-3">
            <p className=' text-left'>사이트 이용 권한 상태</p>
            <ul className="grid w-full gap-2 grid-cols-2 text-center">
              <li>
                <input 
                  id='OK'
                  checked={joinState === '허용' ? true : false}
                  onChange={(e)=>{
                    if(!userIno) return alert('사용자를 먼저 선택해 주세요');
                    if(joinState ===  '허용') return;
                    if(!window.confirm(`${userID}(${userName})님을 이용 허가하시겠습니까?`)) return;
                    setJoinState('허용');
                    UserStateBtn(1);
                  }}
                  type="checkbox"
                  className="hidden peer"
                />
                <label htmlFor='OK' className="grid duration-150 items-center cursor-pointer justify-center text-center w-full px-5 py-2 rounded-lg hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                  <div className="w-full whitespace-nowrap">허용</div>
                </label>
              </li>
              <li>
                <input
                  id="NO"
                  checked={joinState === '차단' ? true : false}
                  onChange={(e)=>{
                    if(!userIno) return alert('사용자를 먼저 선택해 주세요');
                    if(joinState ===  '차단') return;
                    if(!window.confirm(`${userID}(${userName})님을 이용 차단하시겠습니까?`)) return;
                    setJoinState('차단');
                    UserStateBtn(0);
                  }}
                  type="checkbox"
                  className="hidden peer"
                />
                <label htmlFor='NO' className="grid duration-150 items-center cursor-pointer justify-center text-center w-full px-5 py-2 rounded-lg hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                  <div className="w-full whitespace-nowrap">차단</div>
                </label>
              </li>
            </ul>
          </div>

          {/* 언더라인 */}
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          {/* 비밀번호 변경 */}
          <div className='flex flex-col gap-3'>
            <div>
              <p>비밀번호</p>
              <input
                className="bg-[#2E2E2E] mt-1 h-12 w-full p-2 rounded-md outline-none border-[1px] border-gray-400"
                type="password"
                value={userPassword}
                onChange={(e)=>setUserPassword(e.target.value)}
                placeholder="비밀번호">
              </input>
            </div>
            <div>
              <p>비밀번호 확인</p>
              <input
                className="bg-[#2E2E2E] mt-1 h-12 w-full p-2 rounded-md outline-none border-[1px] border-gray-400"
                type="password"
                value={userPasswordCheck}
                onChange={(e)=>setUserPasswordCheck(e.target.value)}
                placeholder="비밀번호 확인">
              </input>
            </div>
            <div>
              <button className="bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300"
              onClick={passwordChenge}>
                비밀번호 변경
              </button>
            </div>
          </div>

          {/* 언더라인 */}
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          {/* 직책 변경 */}
          <div className="grid gap-2">
            <div className="w-full">
              <p>직책 변경</p>
              <select id="storeInput"
                className="w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400"
                value={userPosition}
                onChange={(e)=>setUserPosition(e.target.value)}>
                {positionList.map((item) => (
                  <option value={item} key={item}>
                    {item}
                  </option>
                ))}
              </select>
            </div>

            {/* 직책 변경 */}
            <div className="flex flex-col gap-2">
              <button className="bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300"
              onClick={positionChange}>
                직책 변경
              </button>
            </div>
          </div>
{/* 
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          <div className="flex flex-col gap-2 pt-2">
            <button className="bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300"
            onClick={userLogout}>
              강제 로그아웃
            </button>
          </div> */}

          <div className="flex flex-col gap-2 pt-2">
            <button className="bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300"
            onClick={userDelete}>
              계정 삭제
            </button>
          </div>

          {/* 언더라인 */}
          <div className="border-b-[1px] border-gray-400 py-1"></div>

          {/* 하단 알림말 */}
          <div className="flex flex-col justify-center items-center text-xs mt-3 gap-3 bg-[#2E2E2E] rounded-md p-5">
            <div className="w-[35px] h-[35px] bg-green-600 rounded-md text-center">
              <span className="text-2xl font-bold">!</span>
            </div>
            <div className="text-center">
              <span>
                ※ 해당 페이지는 점장, 사장 직책 사용자만 접근 및 이용이 가능합니다. 선택한 사용자가 변경하고자 하는 계정이 맞는지 다시 한번 확인해 주세요.
              </span>
            </div>
            <div className="text-center">
              <span className="text-gray-400">
                개인정보 및 민감한 기능을 다루는 페이지인 만큼 사용하지 않거나 자리를 비우실 경우 로그아웃을 부탁드립니다.
              </span>
            </div>
          </div>

        </div>
      </div>
    </div>
  )
}

export default StoreUserManagement